import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Shielded from 'react-shielded';
import SubjectIcon from '@material-ui/icons/Subject';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import LogoutIcon from '@material-ui/icons/ExitToApp';

import logo from './kainga-ora-logo.svg';
import styles from './styles.js';

function GlobalDrawerList(props) {
  const { classes, items } = props;

  const addListItem = (
    key,
    icon,
    title,
    active,
    clickHandler,
    customClasses = null
  ) => (
    <ListItem
      button
      component='li'
      key={key}
      onClick={clickHandler}
      className={`${classes.menuItem}
                  ${customClasses ? customClasses : ''}
                  ${active ? classes.menuItemActive : ''} `}
    >
      <ListItemIcon className={classes.menuItemIcon}>{icon}</ListItemIcon>
      <ListItemText
        className={classes.menuItemText}
        classes={{ primary: classes.menuItemTextPrimary }}
        primary={title}
      />
    </ListItem>
  );

  return (
    <div className={classes.root}>
      <List>
        {items.map((item, index) =>
          item
            ? addListItem(
                index,
                item.icon,
                item.title,
                item.active,
                item.clickHandler,
                item.classes
              )
            : null
        )}

        <ListItem className={classes.logoMenuItem}>
          <a
            href={portalContent.APP_HNZ_LINK}
            target='_blank'
            className={`${classes.logoContainer} external`}
            rel='noopener'
          >
            <img
              src={logo}
              alt={'Kāinga Ora - Homes and communities logo'}
              className={classes.logo}
            />
          </a>
          <span className={classes.shielded}>
            <Shielded />
          </span>
        </ListItem>
      </List>
    </div>
  );
}

GlobalDrawerList.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array,
  customerName: PropTypes.string,
};

GlobalDrawerList.defaultProps = {
  items: [],
  customerName: '',
};

export default withStyles(styles)(GlobalDrawerList);
